import { collection } from 'firebase/firestore'
import { firestore } from '../firebaseCore'

export const collectionCompanies = collection(
  firestore,
  'companies',
)
